import { urlForImage } from '../src/app/studio/lib/image';

/**
 * Handles navigation to the previous image in the gallery
 * @param {Object} selectedImage - The currently selected image
 * @param {number} currentImageIndex - The index of the current image
 * @param {Array} galleryImages - Array of Sanity images
 * @param {Array} fallbackImages - Array of fallback images
 * @param {Function} setCurrentImageIndex - State setter for current image index
 * @param {Function} setSelectedImage - State setter for selected image
 */
export const handlePrevImage = (
  selectedImage, 
  currentImageIndex, 
  galleryImages, 
  fallbackImages, 
  setCurrentImageIndex, 
  setSelectedImage
) => {
  if (selectedImage && selectedImage.galleryType) {
    const images = selectedImage.galleryType === 'sanity' ? galleryImages : fallbackImages;
    const newIndex = (currentImageIndex - 1 + images.length) % images.length;
    setCurrentImageIndex(newIndex);
    
    if (selectedImage.galleryType === 'sanity') {
      setSelectedImage({
        src: urlForImage(images[newIndex]),
        alt: `Image ${newIndex + 1}`,
        galleryType: 'sanity',
      });
    } else {
      setSelectedImage({
        src: images[newIndex].src,
        alt: images[newIndex].alt,
        galleryType: 'fallback',
      });
    }
  }
};

/**
 * Handles navigation to the next image in the gallery
 * @param {Object} selectedImage - The currently selected image
 * @param {number} currentImageIndex - The index of the current image
 * @param {Array} galleryImages - Array of Sanity images
 * @param {Array} fallbackImages - Array of fallback images
 * @param {Function} setCurrentImageIndex - State setter for current image index
 * @param {Function} setSelectedImage - State setter for selected image
 */
export const handleNextImage = (
  selectedImage, 
  currentImageIndex, 
  galleryImages, 
  fallbackImages, 
  setCurrentImageIndex, 
  setSelectedImage
) => {
  if (selectedImage && selectedImage.galleryType) {
    const images = selectedImage.galleryType === 'sanity' ? galleryImages : fallbackImages;
    const newIndex = (currentImageIndex + 1) % images.length;
    setCurrentImageIndex(newIndex);
    
    if (selectedImage.galleryType === 'sanity') {
      setSelectedImage({
        src: urlForImage(images[newIndex]),
        alt: `Image ${newIndex + 1}`,
        galleryType: 'sanity',
      });
    } else {
      setSelectedImage({
        src: images[newIndex].src,
        alt: images[newIndex].alt,
        galleryType: 'fallback',
      });
    }
  }
};

/**
 * Handles clicking on a Sanity image
 * @param {string} imageUrl - URL of the clicked image
 * @param {string} alt - Alt text for the image
 * @param {number} index - Index of the clicked image in the gallery
 * @param {Function} setCurrentImageIndex - State setter for current image index
 * @param {Function} setSelectedImage - State setter for selected image
 */
export const handleSanityImageClick = (
  imageUrl, 
  alt, 
  index, 
  setCurrentImageIndex, 
  setSelectedImage
) => {
  setCurrentImageIndex(index);
  setSelectedImage({
    src: imageUrl,
    alt: alt,
    galleryType: 'sanity'
  });
};

/**
 * Handles clicking on a fallback image
 * @param {Object} image - The clicked image object
 * @param {number} index - Index of the clicked image in the gallery
 * @param {Function} setCurrentImageIndex - State setter for current image index
 * @param {Function} setSelectedImage - State setter for selected image
 */
export const handleFallbackImageClick = (
  image, 
  index, 
  setCurrentImageIndex, 
  setSelectedImage
) => {
  setCurrentImageIndex(index);
  setSelectedImage({
    ...image,
    galleryType: 'fallback'
  });
}; 